import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import BloquesPedagogicosView from './BloquesPedagogicosView';
import * as ROUTES from '../../../router/Routes';

const BloquesPedagogicosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.bloquesPedagogicos}
      routes={[ROUTES.controlEstudios]}
    >
      <BloquesPedagogicosView />
    </ContainerTemplate>
  );
};

export default BloquesPedagogicosModule;
